<template>
  <div>
    <button
      style="display: none"
      type="button"
      id="btn-show-dashboard-component"
      data-bs-toggle="modal"
      data-bs-target="#modalAddDashboardElement"
    ></button>
    <div
      class="modal fade"
      id="modalAddDashboardElement"
      tabindex="-1"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header">
            <div>
              <h5 class="modal-title">DASHBOARD COMPONENT</h5>
              <div class="dc-subtitle">
                {{ selectedCount }} / {{ currentItems.length }} shown
                <span v-if="limit < currentItems.length">· up to {{ limit }}</span>
              </div>
            </div>
            <div class="dc-actions">
              <button type="button" class="dc-link" @click="setAll(true)">Select all</button>
              <button type="button" class="dc-link" @click="setAll(false)">Clear</button>
            </div>
          </div>
          <div class="modal-body">
            <div v-for="group in groups[configType]" :key="group.title">
              <div class="title-page dc-group-title">{{ group.title }}</div>
              <label
                v-for="item in group.items"
                :key="item.key"
                class="dc-item label-form"
                :class="{ 'dc-item-disabled': isDisabled(item.key) }"
              >
                <span class="dc-item-label">
                  <i class="material-icons-round">{{ item.icon }}</i>
                  {{ item.label }}
                </span>
                <span class="dc-switch">
                  <input
                    type="checkbox"
                    v-model="form[item.key]"
                    :disabled="isDisabled(item.key)"
                  />
                  <span class="dc-slider"></span>
                </span>
              </label>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-primary btn-close-modal btn-sm"
              data-bs-dismiss="modal"
            >
              Cancel
            </button>
            <button
              type="button"
              class="btn btn-success btn-background btn-sm"
              @click="saveConfig"
            >
              Save
            </button>
          </div>
          <MaterialLoading :active="loaderActive" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DashboardService from "../services/dashboard.service";
import $ from "jquery";
import MaterialLoading from "@/components/MaterialLoading.vue";

// What each settings screen lists, in display order. `on` is the default when
// the merchant never saved this screen.
const GROUPS = {
  card: [
    {
      title: "Grand Card",
      items: [
        { key: "totalSales", label: "Total Sales", icon: "payments", on: true },
        { key: "netSales", label: "Net Sales", icon: "account_balance_wallet", on: true },
        { key: "transactions", label: "Transactions", icon: "receipt", on: true },
        { key: "memberTransactions", label: "Member Transactions", icon: "card_membership", on: true },
      ],
    },
    {
      title: "Info Card",
      items: [
        { key: "serviceCharge", label: "Service Charge", icon: "room_service", on: false },
        { key: "gst", label: "GST", icon: "percent", on: false },
        { key: "billDiscount", label: "Bill Discount", icon: "sell", on: false },
        { key: "avgBillSize", label: "Avg Bill Size", icon: "functions", on: false },
        { key: "voidAmount", label: "Void Amount", icon: "block", on: false },
        { key: "totalMembers", label: "Total Members", icon: "groups", on: false },
        { key: "totalPax", label: "Total Pax", icon: "people", on: false },
        { key: "spendingPerPax", label: "Spending Per Pax", icon: "person", on: false },
      ],
    },
  ],
  shortcut: [
    {
      title: "Shortcut",
      items: [
        { key: "viewMember", label: "View A Member", icon: "person_search", on: true },
        { key: "menuSet", label: "Menu Set", icon: "menu", on: true },
        { key: "orderStatus", label: "Order Status", icon: "toc", on: true },
        { key: "stockLinks", label: "Item On/Off", icon: "inventory_2", on: true },
        { key: "kds", label: "KDS", icon: "kitchen", on: true },
        { key: "dailyCollection", label: "Daily Collection", icon: "assessment", on: true },
        { key: "itemSales", label: "Item Sales Report", icon: "assessment", on: true },
        { key: "itemSalesWithModifiers", label: "Item Sales with Modifiers", icon: "assessment", on: true },
        { key: "paidOnlineOrders", label: "Paid Online Orders", icon: "assessment", on: true },
        { key: "paidKioskOrders", label: "Paid Kiosk Orders", icon: "assessment", on: true },
        { key: "posTransactions", label: "POS Transactions", icon: "assessment", on: true },
        { key: "posSimulator", label: "POS Simulator", icon: "point_of_sale", on: true },
        { key: "stockInOut", label: "Stock In/Out", icon: "inventory_2", on: true },
        { key: "stockTransfers", label: "Stock Transfers", icon: "compare_arrows", on: true },
        { key: "salesChannel", label: "Sales Channel", icon: "storefront", on: true },
      ],
    },
  ],
  chart: [
    {
      title: "Chart",
      items: [
        { key: "spendingLeaderboard", label: "Spending Leaderboard", icon: "emoji_events", on: false },
        { key: "recentTransactions", label: "Recent Transactions", icon: "history", on: true },
        { key: "branchesRevenueLeaderboard", label: "Branches Revenue Leaderboard", icon: "bar_chart", on: true },
        { key: "itemsRevenueLeaderboardByType", label: "Items Revenue Leaderboard By Type", icon: "stacked_bar_chart", on: false },
        { key: "itemsRevenueLeaderboard", label: "Items Revenue Leaderboard", icon: "align_horizontal_left", on: false },
        { key: "categorySales", label: "Category Sales Report", icon: "category", on: true },
      ],
    },
  ],
  eod: [
    {
      title: "EOD Summary",
      items: [
        { key: "operationSummary", label: "Operation Summary", icon: "summarize", on: true },
        { key: "orderSource", label: "Order Source", icon: "hub", on: true },
        { key: "discount", label: "Discount", icon: "sell", on: true },
        { key: "paymentSummary", label: "Payment Summary", icon: "payments", on: true },
        { key: "topup", label: "Minty Topup Payments", icon: "account_balance_wallet", on: true },
        { key: "cashback", label: "Member Cashback Summary", icon: "redeem", on: true },
        { key: "groupSummary", label: "Group Summary", icon: "category", on: true },
        { key: "addOnSummary", label: "Add-on Summary", icon: "add_circle", on: true },
      ],
    },
  ],
};

// How many items each screen may show at once.
const LIMITS = { card: 12, shortcut: 15, chart: 4, eod: 8 };

const defaultsFor = (type) => {
  const form = {};
  (GROUPS[type] || []).forEach((group) => group.items.forEach((item) => (form[item.key] = item.on)));
  return form;
};

export default {
  name: "DashboardComponet",
  components: {
    MaterialLoading,
  },
  props: {
    configType: {
      type: String,
      default: "card",
    },
    keyReload: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      loaderActive: false,
      groups: GROUPS,
      form: defaultsFor(this.configType),
    };
  },
  computed: {
    currentItems() {
      return (GROUPS[this.configType] || []).flatMap((group) => group.items);
    },
    selectedCount() {
      return this.currentItems.filter((item) => this.form[item.key]).length;
    },
    limit() {
      return LIMITS[this.configType] || this.currentItems.length;
    },
  },
  created() {
    this.getConfig();
  },
  methods: {
    isDisabled(key) {
      return !this.form[key] && this.selectedCount >= this.limit;
    },
    setAll(on) {
      const form = { ...this.form };
      let count = 0;

      this.currentItems.forEach((item) => {
        form[item.key] = on && count < this.limit;
        if (form[item.key]) {
          count++;
        }
      });

      this.form = form;
    },
    getConfig() {
      this.loaderActive = true;

      DashboardService.config({ action: "list", type: this.configType }).then(
        (response) => {
          if (response.data.result.isSuccess && response.data.data) {
            // A key saved before it existed (e.g. categorySales) keeps its default.
            this.form = { ...defaultsFor(this.configType), ...response.data.data };
          }
          this.loaderActive = false;
        },
        (error) => {
          console.log(error);
          this.loaderActive = false;
        }
      );
    },
    saveConfig() {
      const config = { ...this.form };

      DashboardService.config({ action: "createOrUpdate", type: this.configType, config }).then(
        (response) => {
          if (response.data.result.isSuccess) {
            this.$emit("reload-data", config);
            $(".btn-close-modal").click();
          }
        },
        (error) => {
          console.log(error);
        }
      );
    },
  },
  watch: {
    keyReload: function () {
      this.form = defaultsFor(this.configType);
      this.getConfig();
    },
  },
};
</script>

<style scoped>

.modal-header {
  align-items: flex-start;
}


.dc-subtitle {
  font-size: 12.5px;
  margin-top: 2px;
}

.dc-actions {
  display: flex;
  gap: 12px;
}

.dc-link {
  border: none;
  background: transparent;
  padding: 0;
  color: #1871bd;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
}

.modal-body {
  max-height: 65vh;
  overflow-y: auto;
}

.dc-group-title {
  margin: 8px 0 4px;
}

.dc-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
  margin: 0;
  padding: 8px 4px;
  border-bottom: 1px solid #f0f2f5;
  cursor: pointer;
}

.dc-item:hover {
  background: #f8f9fa;
}

.dc-item-disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.dc-item-label {
  display: flex;
  align-items: center;
  gap: 10px;
}

.dc-item-label .material-icons-round {
  font-size: 18px;
  color: #133067;
}

.dc-switch {
  position: relative;
  flex: 0 0 auto;
  width: 38px;
  height: 22px;
}

.dc-switch input {
  position: absolute;
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: inherit;
}

.dc-slider {
  position: absolute;
  inset: 0;
  border-radius: 999px;
  background: #d2d6da;
  transition: background 0.15s ease;
  pointer-events: none;
}

.dc-slider::before {
  content: "";
  position: absolute;
  top: 3px;
  left: 3px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background: #fff;
  transition: transform 0.15s ease;
}

.dc-switch input:checked + .dc-slider {
  background: #1871bd;
}

.dc-switch input:checked + .dc-slider::before {
  transform: translateX(16px);
}

.dc-switch input:focus-visible + .dc-slider {
  outline: 2px solid #1871bd;
  outline-offset: 2px;
}

</style>
